import React, { useMemo, useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { View } from 'react-native';
import { AppView, Indicator, withAnimatedNavigationHeader } from 'design-system';
import { SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { FlashList } from '@shopify/flash-list';
import { useAppSelector } from 'store/hooks';
import { useActivities } from '../hooks';
import { createActivitySections } from '../utils';
import EmptyState from '../components/EmptyState';
import InvestActivityRow from '../components/InvestActivityRow';
import { selectTradingAccount } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const emptyActivities = [];
const ActivityScreen = withAnimatedNavigationHeader(({ route, scrollHandler }) => {
    const forceReloadConfig = route.params?.forceReloadConfig;
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingAccountId = tradingAccount?.account.id;
    const [activities, onLoadNextPage, , loading] = useActivities(route.params?.assetId, tradingAccountId, forceReloadConfig);
    const pendingActivities = useAppSelector((state) => 
    // eslint-disable-next-line no-nested-ternary
    (route.params?.assetId
        ? emptyActivities
        : tradingAccountId
            ? state.unpersistedInvestReducer.pendingActivitiesForTradingAccount?.[tradingAccountId]
            : emptyActivities) || emptyActivities);
    const flashListData = useMemo(() => {
        if (activities) {
            const result = createActivitySections(activities, pendingActivities, {
                withStatements: !route.params?.assetId,
            });
            return result;
        }
        return [];
    }, [activities, pendingActivities, route.params?.assetId]);
    const renderItem = useCallback(({ item }) => <InvestActivityRow item={item}/>, []);
    const keyExtractor = useCallback((item) => ('id' in item ? item.id : `${item.month}-${item.year}`), []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const content = useMemo(() => {
        if (loading) {
            return <Indicator dark/>;
        }
        if (flashListData.length === 0) {
            return (<View style={paddingHorizontalStyle}>
            <EmptyState activity/>
          </View>);
        }
        return (<AnimatedFlashList data={flashListData} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} keyExtractor={keyExtractor} onEndReached={onLoadNextPage} contentContainerStyle={contentContainerStyle} showsVerticalScrollIndicator scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>);
    }, [
        loading,
        flashListData,
        renderItem,
        scrollHandler,
        keyExtractor,
        onLoadNextPage,
        contentContainerStyle,
        paddingHorizontalStyle,
    ]);
    return <AppView withFrame={false}>{content}</AppView>;
}, ({ colors }) => ({
    title: 'Activity',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default ActivityScreen;
